export default __webpack_public_path__ + "static/media/border-2.538067fd.png";